import React, {useState} from 'react'
import {useGalleryEntries} from "../../../hooks/galleryhook";

function GameGallery() {
    const [galleryEntries] = useGalleryEntries(12);
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <div className="game-gallery-area position-relative">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4">
                            <h2>Game <span>Gallery</span></h2>
                        </div>
                    </div>
                </div>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '12px',
                }}>
                    {galleryEntries?.map((entry, index) => (
                        <div
                            key={entry.id || index}
                            style={{
                                overflow: 'hidden',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                aspectRatio: '16 / 10',
                            }}
                            onClick={() => setSelectedImage(entry)}
                        >
                            <img
                                src={entry.url}
                                alt={entry.caption || 'Starpath screenshot'}
                                loading="lazy"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease',
                                }}
                                onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Lightbox overlay */}
            {selectedImage && (
                <div
                    onClick={() => setSelectedImage(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0, 0, 0, 0.9)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        cursor: 'pointer',
                        padding: '2rem',
                    }}
                >
                    <img
                        src={selectedImage.url}
                        alt={selectedImage.caption || 'Starpath screenshot'}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default GameGallery
